var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { Delete, MoreVert, Upload } from "@mui/icons-material";
import { Box, Chip, Typography } from "@mui/material";
import { ExportIconSVG } from "../../../assets/customIcons";
import { DynamicFormBuilderContainer } from "../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container";
import { FormItemTypes } from "../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity";
import ActionMenuList from "../../../builderPackage/components/actionsMenuList";
import { showSurface } from "../../../redux/awaitedSurfacesSlice";
import { useAppDispatch } from "../../../store/hooks";
import { systemColor } from "../../../theme/systemColor";
import { JCNoByOrganizationAPICall, LabourListAPICall } from "../services/apiCall";
import { LOCAL_STORAGE_KEYS } from "../../../constants";
import { getLocalStorageItem } from "../../../utils/storageHelper";
import { faintblue, faintGray } from "../../../theme/palette";
var WorkOrderDetailTabMobView = function (props) {
    var _getLocalStorageItem, _getLocalStorageItem2;
    var id = props.id, onChange = props.onChange, value = props.value, error = props.error, _a = props.name, name = _a === void 0 ? 'WPODetails' : _a;
    var dispatch = useAppDispatch();
    var UserOrganization = (_getLocalStorageItem = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA)) === null || _getLocalStorageItem === void 0 || (_getLocalStorageItem = _getLocalStorageItem.data) === null || _getLocalStorageItem === void 0 || (_getLocalStorageItem = _getLocalStorageItem.Branches[0]) === null || _getLocalStorageItem === void 0 ? void 0 : _getLocalStorageItem.OrganizationId;
    var UserParentOrganization = (_getLocalStorageItem2 = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA)) === null || _getLocalStorageItem2 === void 0 || (_getLocalStorageItem2 = _getLocalStorageItem2.data) === null || _getLocalStorageItem2 === void 0 || (_getLocalStorageItem2 = _getLocalStorageItem2.Branches[0]) === null || _getLocalStorageItem2 === void 0 ? void 0 : _getLocalStorageItem2.ParentOrganizationId;
    var JCNoBySuppliernAPICall = function (params) { return JCNoByOrganizationAPICall(_objectSpread(_objectSpread({}, params), {}, {
        request: _objectSpread({
            OrganizationId: UserOrganization,
            ParentOrganization: UserParentOrganization
        }, params.request)
    })); };
    var LabourListBysupplier = function (params) { return LabourListAPICall(_objectSpread(_objectSpread({}, params), {}, {
        request: _objectSpread({
            SupplierId: value === null || value === void 0 ? void 0 : value.SupplierId
        }, params.request)
    })); };
    var listFormElements = [{
            type: FormItemTypes.ContainerItem,
            name: '',
            columnSize: 12,
            elements: [{
                    type: FormItemTypes.CardComponent,
                    name: '',
                    label: undefined,
                    value: null,
                    sm: 12,
                    md: 6,
                    sx: {
                        bgcolor: faintblue,
                        borderRadius: 2,
                        borderColor: faintGray
                    },
                    elements: [{
                            type: FormItemTypes.Custom,
                            name: 'StatusName',
                            label: 'Status :',
                            value: null,
                            columnSize: 12,
                            containerProps: {
                                container: true,
                                justifyContent: 'space-between',
                                alignItems: 'center'
                            },
                            labelTypographyProps: {
                                variant: 'h6',
                                mb: 0
                            },
                            element: function () { /*#__PURE__*/ return React.createElement(Chip, {
                                label: "Active",
                                size: "small",
                                variant: "outlined",
                                color: "info",
                                sx: {
                                    borderRadius: 2,
                                    px: 1,
                                    typography: 'h6',
                                    color: 'info'
                                },
                                icon: /*#__PURE__*/ React.createElement(Box, {
                                    height: 6,
                                    width: 6,
                                    borderRadius: 10,
                                    bgcolor: systemColor.borderColor
                                })
                            }); }
                        }, {
                            type: FormItemTypes.Typography,
                            name: 'CreatedBy',
                            label: 'Created By :',
                            value: 'Micheal Adams',
                            columnSize: 12,
                            containerProps: {
                                container: true,
                                justifyContent: 'space-between',
                                alignItems: 'center'
                            },
                            labelTypographyProps: {
                                variant: 'h6',
                                mb: 0
                            },
                            variant: 'h6'
                        }]
                }, {
                    type: FormItemTypes.SearchSelect,
                    name: 'UOM',
                    label: 'UOM',
                    value: null,
                    columnSize: 12,
                    options: [{
                            id: 'g',
                            Name: 'g'
                        }, {
                            id: 'ml',
                            Name: 'ml'
                        }],
                    required: true
                }, {
                    type: FormItemTypes.NumberInput,
                    name: 'Rate',
                    label: 'Rate(₹)',
                    value: null,
                    xs: 6,
                    required: true
                }, {
                    type: FormItemTypes.NumberInput,
                    name: 'RequestedQuantity',
                    label: 'Quantity',
                    value: null,
                    xs: 6,
                    required: true
                }, {
                    type: FormItemTypes.NumberInput,
                    name: 'TaxAmount',
                    label: 'Taxes (₹)',
                    value: null,
                    disabled: true,
                    valueGetter: function (formValues, field) {
                        return (formValues === null || formValues === void 0 ? void 0 : formValues.Quantity) * (formValues === null || formValues === void 0 ? void 0 : formValues.Rate) * (Number(formValues === null || formValues === void 0 ? void 0 : formValues.TaxesPercentage) / 100);
                    },
                    xs: 8
                }, {
                    type: FormItemTypes.NumberInput,
                    name: 'Taxes',
                    label: 'Taxes (%)',
                    value: null,
                    xs: 4,
                    setFieldProps: function (state) { return ({
                        type: FormItemTypes.NumberInput,
                        disabled: !Boolean((state === null || state === void 0 ? void 0 : state.Rate) && (state === null || state === void 0 ? void 0 : state.Quantity))
                    }); }
                }, {
                    type: FormItemTypes.NumberInput,
                    name: 'DiscountRate',
                    label: 'Discount (₹)',
                    value: null,
                    disabled: true,
                    valueGetter: function (formValues, field) {
                        return (formValues === null || formValues === void 0 ? void 0 : formValues.Quantity) * (formValues === null || formValues === void 0 ? void 0 : formValues.Rate) * (Number(formValues === null || formValues === void 0 ? void 0 : formValues.DiscountPercentage) / 100);
                    },
                    xs: 8
                }, {
                    type: FormItemTypes.NumberInput,
                    name: 'Discount',
                    label: 'Discount (%)',
                    value: null,
                    xs: 4,
                    setFieldProps: function (state) { return ({
                        type: FormItemTypes.NumberInput,
                        disabled: !Boolean((state === null || state === void 0 ? void 0 : state.Rate) && (state === null || state === void 0 ? void 0 : state.Quantity))
                    }); }
                }, {
                    type: FormItemTypes.NumberInput,
                    name: 'TotalAmount',
                    label: 'Total Amount',
                    value: null,
                    disabled: true,
                    valueGetter: function (formValues) {
                        var amount = (formValues === null || formValues === void 0 ? void 0 : formValues.Quantity) * (formValues === null || formValues === void 0 ? void 0 : formValues.Rate);
                        var factor = (Number((formValues === null || formValues === void 0 ? void 0 : formValues.TaxesPercentage) || 0) - Number((formValues === null || formValues === void 0 ? void 0 : formValues.DiscountPercentage) || 0)) / 100;
                        var total = (1 + factor) * amount;
                        return Math.fround(total);
                    }
                }, {
                    type: FormItemTypes.TextInput,
                    name: 'Remarks',
                    label: 'Remarks',
                    value: null,
                    multiline: true,
                    minRows: 3,
                    md: 6
                }]
        }];
    var workOrderDetails = [{
            type: FormItemTypes.CardComponent,
            name: '',
            elements: [{
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    elements: [{
                            type: FormItemTypes.SearchSelect,
                            name: 'Parts',
                            multiple: true,
                            disableCloseOnSelect: true,
                            apiKey: 'Products',
                            getListData: JCNoBySuppliernAPICall,
                            renderTags: function () { return null; },
                            clearText: 'Clear Selected Parts',
                            columnSize: true,
                            placeholder: 'Search Parts',
                            setFormState: function (state, value) { return value !== null && value !== void 0 && value.length ? {
                                PartDetailsMobile: value
                            } : {}; },
                            valueGetter: function (state) { return state === null || state === void 0 ? void 0 : state.PartDetailsMobile; }
                        }, {
                            type: FormItemTypes.Button,
                            name: 'More',
                            children: /*#__PURE__*/ React.createElement(MoreVert, null),
                            size: 'small',
                            variant: 'outlined',
                            color: 'secondary',
                            sx: {
                                p: '7px'
                            },
                            columnSize: 0,
                            setFormState: function (state, e) { return __awaiter(void 0, void 0, void 0, function () {
                                var action, PartDetailsMobile, _PartDetailsMobile;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, dispatch(showSurface({
                                                type: 'Menu',
                                                containerProps: {
                                                    anchorEl: e.target.parentElement
                                                },
                                                Component: ActionMenuList,
                                                componentProps: {
                                                    items: [{
                                                            id: 'delete',
                                                            children: [/*#__PURE__*/ React.createElement(Delete, {
                                                                    color: "secondary",
                                                                    fontSize: "small"
                                                                }), "Delete"]
                                                        }, {
                                                            id: 'upload',
                                                            children: [/*#__PURE__*/ React.createElement(Upload, {
                                                                    color: "secondary",
                                                                    fontSize: "small"
                                                                }), "Upload"]
                                                        }, {
                                                            id: 'export',
                                                            children: /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(ExportIconSVG, {
                                                                fontSize: "small"
                                                            }), " Export ")
                                                        }]
                                                }
                                            }))];
                                        case 1:
                                            action = _a.sent();
                                            PartDetailsMobile = state === null || state === void 0 ? void 0 : state.PartDetailsMobile;
                                            if ((action === null || action === void 0 ? void 0 : action.payload) === 'delete') {
                                                PartDetailsMobile = (_PartDetailsMobile = PartDetailsMobile) === null || _PartDetailsMobile === void 0 ? void 0 : _PartDetailsMobile.filter(function (p) { return !p.Selected; });
                                            }
                                            return [2 /*return*/, {
                                                    PartDetailsMobile: PartDetailsMobile
                                                }];
                                    }
                                });
                            }); }
                        }],
                    xs: 12,
                    sm: 8,
                    md: 6,
                    spacing: 1
                }, {
                    type: FormItemTypes.CheckBox,
                    name: 'SelectAll',
                    label: 'Select All',
                    value: null,
                    columnSize: 12,
                    setFormState: function (state, checked) {
                        var _state$PartDetailsMob;
                        return {
                            PartDetailsMobile: state === null || state === void 0 || (_state$PartDetailsMob = state.PartDetailsMobile) === null || _state$PartDetailsMob === void 0 ? void 0 : _state$PartDetailsMob.map(function (p) { return _objectSpread(_objectSpread({}, p), {}, {
                                Selected: checked
                            }); })
                        };
                    }
                }, {
                    type: FormItemTypes.List,
                    name: 'PartDetailsMobile',
                    columnSize: 12,
                    value: [{
                            id: 0,
                            DisplayName: 'Screw',
                            SkuCode: '#032948',
                            Status: 'info'
                        }],
                    variant: 'compact',
                    error: error === null || error === void 0 ? void 0 : error[name],
                    // disableCheckboxSelection: true,
                    // disableDetailsPanel: true,
                    // getRowHeight: () => 'auto',
                    columns: [{
                            field: 'Part',
                            flex: 1,
                            renderCell: function (params) {
                                var _params$row$DisplayNa;
                                return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Typography, {
                                    variant: "h3"
                                }, (_params$row$DisplayNa = params.row.DisplayName) !== null && _params$row$DisplayNa !== void 0 ? _params$row$DisplayNa : params.row.Name), /*#__PURE__*/ React.createElement(Typography, {
                                    variant: "h6",
                                    color: "secondary"
                                }, params.row.Code ? '#' + params.row.Code : ''));
                            }
                        }],
                    elements: listFormElements
                }],
            columnSize: 12,
            containerProps: {
                display: {
                    xs: 'block',
                    sm: 'none'
                }
            }
        }];
    return /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        formData: workOrderDetails,
        mode: "add",
        onChange: onChange
    });
};
export default WorkOrderDetailTabMobView;
